import { Button, Icon } from '../../../atoms'
import React from 'react'
import { ProfileFormData } from './utils'

interface inEligibleProps {
  setPrefillProfile: (value: React.SetStateAction<ProfileFormData | null>) => void
}

const InEligible: React.FC<inEligibleProps> = ({ setPrefillProfile }) => {
  return (
    <div className='SMEform__inEligible'>
      <div className='SMEform__infoBox'>
        <Icon glyph='info-blob' size={24} />
        <div>
          <strong>Available for limited companies only.</strong>
          <br /> Based on the information provided, it appears you are registered as a sole trader.
          If this is inaccurate, you can proceed by entering your limited company details or explore
          options specifically tailored to sole traders
        </div>
      </div>
      <div className='SMEform__inEligible__ctaWrapper'>
        <Button href='/business/business-loans/sole-traders' variant='primary' size='md'>
          Explore other options
        </Button>
        <Button
          onClick={() => {
            setPrefillProfile(null)
          }}
          variant='secondary'
          size='md'
        >
          Continue as limited company
        </Button>
      </div>
    </div>
  )
}

export default InEligible
